import { PlatformSlug } from 'constants/consts'
import { PlatformName } from '__generatedTypes__/globalTypes'
import { cmsRoutes, RouteValue } from 'routes/cmsRoutes'

export const PLATFORM_SLUG_TO_NAME: Record<PlatformSlug, PlatformName> = {
  [PlatformSlug.DATBooster]: PlatformName.DATBooster,
  [PlatformSlug.OATBooster]: PlatformName.OATBooster,
  [PlatformSlug.DATCrusher]: PlatformName.DATCrusher,
  [PlatformSlug.PATBooster]: PlatformName.PATBooster,
  [PlatformSlug.INBDEBooster]: PlatformName.INBDEBooster,
  [PlatformSlug.CasperBooster]: PlatformName.CasperBooster,
  [PlatformSlug.Admissions]: PlatformName.Admissions,
  [PlatformSlug.NBDHEBooster]: PlatformName.NBDHEBooster,
  [PlatformSlug.NDEBCrusher]: PlatformName.NDEBCrusher,
  [PlatformSlug.CARSBooster]: PlatformName.CARSBooster,
  [PlatformSlug.MCATBooster]: PlatformName.MCATBooster,
  [PlatformSlug.GREBooster]: PlatformName.GREBooster,
  [PlatformSlug.NBEOPartOne]: PlatformName.NBEOPartOne,
  [PlatformSlug.DLOSCE]: PlatformName.DLOSCE,
}

export const PLATFORM_NAME_TO_SLUG: Record<PlatformName, PlatformSlug> = {
  [PlatformName.DATBooster]: PlatformSlug.DATBooster,
  [PlatformName.OATBooster]: PlatformSlug.OATBooster,
  [PlatformName.DATCrusher]: PlatformSlug.DATCrusher,
  [PlatformName.PATBooster]: PlatformSlug.PATBooster,
  [PlatformName.INBDEBooster]: PlatformSlug.INBDEBooster,
  [PlatformName.CasperBooster]: PlatformSlug.CasperBooster,
  [PlatformName.Admissions]: PlatformSlug.Admissions,
  [PlatformName.NBDHEBooster]: PlatformSlug.NBDHEBooster,
  [PlatformName.NDEBCrusher]: PlatformSlug.NDEBCrusher,
  [PlatformName.CARSBooster]: PlatformSlug.CARSBooster,
  [PlatformName.MCATBooster]: PlatformSlug.MCATBooster,
  [PlatformName.GREBooster]: PlatformSlug.GREBooster,
  [PlatformName.NBEOPartOne]: PlatformSlug.NBEOPartOne,
  [PlatformName.DLOSCE]: PlatformSlug.DLOSCE,
}

export const PLATFORM_DISPLAY_NAME: Partial<Record<PlatformName, string>> = {
  [PlatformName.NDEBCrusher]: 'Virtual OSCE® Prep',
  [PlatformName.NBEOPartOne]: 'NBEO® Part 1 Prep',
  [PlatformName.DLOSCE]: 'DLOSCE® Prep',
}

export const PLATFORM_DEFAULT_ROUTE: Record<PlatformSlug, RouteValue> = {
  [PlatformSlug.DATBooster]: cmsRoutes.CRASH_COURSE_LIST,
  [PlatformSlug.OATBooster]: cmsRoutes.CRASH_COURSE_LIST,
  [PlatformSlug.DATCrusher]: cmsRoutes.CRASH_COURSE_LIST,
  [PlatformSlug.PATBooster]: cmsRoutes.CRASH_COURSE_LIST,
  [PlatformSlug.INBDEBooster]: cmsRoutes.BLOG_PAGES,
  [PlatformSlug.NBDHEBooster]: cmsRoutes.BLOG_PAGES,
  [PlatformSlug.NDEBCrusher]: cmsRoutes.BLOG_PAGES,
  [PlatformSlug.GREBooster]: cmsRoutes.BLOG_PAGES,
  [PlatformSlug.NBEOPartOne]: cmsRoutes.BLOG_PAGES,
  [PlatformSlug.DLOSCE]: cmsRoutes.BLOG_PAGES,
  [PlatformSlug.Admissions]: cmsRoutes.DENTISTRY,
  [PlatformSlug.CasperBooster]: cmsRoutes.QUESTION_LIST,
  [PlatformSlug.CARSBooster]: cmsRoutes.QUESTION_LIST,
  [PlatformSlug.MCATBooster]: cmsRoutes.CARS_PLUGIN,
}

export const getPlatformFullNameBySlug = (platformSlug: string) =>
  PLATFORM_SLUG_TO_NAME[platformSlug as PlatformSlug] ?? platformSlug.toUpperCase()

export const getPlatformSlugByName = (platformName: PlatformName) => PLATFORM_NAME_TO_SLUG[platformName]

export const getFullPlatformTitle = (platformName?: PlatformName) =>
  (platformName && PLATFORM_DISPLAY_NAME[platformName]) || platformName

export const getPlatformDefaultRoute = (platformSlug: PlatformSlug) => PLATFORM_DEFAULT_ROUTE[platformSlug]
